import { useMemo } from 'react';

import { useWorkspacePermissions } from '~/hooks/useWorkspacePermissions';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { canEditContextSources, canViewContextSources } from '~/utils/permissions/workspacePermissions';

export const usePrivateContextSourcesPermissions = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { workspacePermissions } = useWorkspacePermissions({
    workspaceId: currentWorkspace?.id,
  });

  return useMemo(
    () => ({
      canEdit: canEditContextSources(workspacePermissions),
      canView: canViewContextSources(workspacePermissions),
    }),
    [workspacePermissions],
  );
};
